<form [formGroup]="form" nz-form>
    <div class="pf-form-group compact column">
        <pf-input
            inputType="number"
            label="Copies"
            pfStyle="block"
            controlName="copies"></pf-input>
        <div class="printer-select">
            @if (availablePrinters?.length) {
                <pf-select
                    label="Available Printers"
                    placeholder="Select a printer"
                    pfStyle="block"
                    [data]="availablePrinters"
                    [pfDisabled]="!!form.value.printer"
                    (selected)="onPrinterSelected($event)"
                    controlName="printerSelect"></pf-select>
                <span>OR</span>
            }
            <pf-input
                inputType="text"
                label="Printer"
                placeholder="Scan or enter printer address"
                pfStyle="block"
                (pfInput)="onPrinterInput($event)"
                [pfDisabled]="!!form.value.printerSelect"
                controlName="printer"></pf-input>
        </div>
        <pf-text>
            {{ labelCount }} labels x {{ copies }} copies =
            {{ totalLabels }} total labels
        </pf-text>
    </div>
</form>
